import Vue from 'vue';
import Router from 'vue-router';
import { getCookie, setCookie, clearAlltimer } from '@/util/util';
// import store from "../store"

Vue.use(Router);

const router = new Router({
  // hashbang: true,
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/auth',
      name: '欢迎使用移动能源交易平台',
      // redirect: '/home',
      component: resolve => require(['@/pages/auth/auth'], resolve),
    },
    {
      path: '/home',
      name: '欢迎使用移动能源交易平台',
      component: resolve => require(['@/pages/home/home'], resolve),
    },
    {
      path: '/equipconfirm',
      name: ' 充电桩详情',
      component: resolve => require(['@/pages/equipconfirm/equipconfirm'], resolve),
    },
    {
      path: '/choosetype',
      name: '欢迎使用移动能源交易平台',
      component: resolve => require(['@/pages/choosetype/choosetype'], resolve),
    },
    {
      path: '/charging/:id',
      name: '充电中',
      component: resolve => require(['@/pages/charging/charging'], resolve),
    },
    {
      path: '/rent',
      name: ' 激活充电包',
      component: resolve => require(['@/pages/rent/rent'], resolve),
    },
    {
      path: '/rentcharging/:id',
      name: '充电包详情',
      component: resolve => require(['@/pages/rentcharging/rentcharging'], resolve),
    },
    {
      path: '/rentequips',
      name: '移动能源租用设备',
      component: resolve => require(['@/pages/rentequips/rentequips'], resolve),
    },
    {
      path: '/rentequipsdetail/:id',
      name: '移动能源租用设备 ',
      component: resolve => require(['@/pages/rentequips/rentequipsdetail'], resolve),
    },
    {
      path: '/usercenter',
      redirect: '/usercenter/charge',
      name: '我的充电设备',
      component: resolve => require(['@/pages/usercenter/usercenter'], resolve),
      children:[{
        path: '/usercenter/charge',
        name: '个人中心',
        component: resolve => require(['@/pages/usercenter/children/charge'], resolve)
      },{
        path: '/usercenter/rent',
        name: '我的租用设备',
        component: resolve => require(['@/pages/usercenter/children/rent'], resolve)
      }]
    },
    {
      path: '/service',
      name: '应急充电',
      component: resolve => require(['@/pages/service/service'], resolve),
    }
  ],
});
export default router;

router.beforeEach((to,from,next) => {
  if(to.path == '/auth' && getCookie('token')){
    console.log('secondIn');
    // 用户使用后退返回到授权页，则默认回到首页
    next({ path: '/home' })
    return false
  }
  console.log(getCookie('token'), to.path)
  console.log(!to.path != '/auth')
  if(!getCookie('token') && to.path != '/auth'){
    // 第一次进入项目
    console.log('fisrtIn');
    if (to.path != '/home') {
      // alert(to.fullPath)
      setCookie('beforeLoginUrl', to.fullPath) // 保存用户进入的url
    }
    next({ path: '/auth' })
    return false
  }
  next()
});

router.afterEach((to, from, next) => {
  console.log(`成功浏览到: ${to.path}`);
  // console.log(from);
  if (from.fullPath.indexOf('charging') != -1 || from.fullPath.indexOf('rentcharging') != -1) {
    clearAlltimer();
  }
  document.title = to.name;
  window.scrollTo(0, 0);
});




// WEBPACK FOOTER //
// ./src/router/index.js